import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';

import Anchor from '../Anchor';
import Column from '../Column';
import Grid from '../Grid';
import Row from '../Row';
import Theme from '../../theme';

import Avatar from './Avatar';
import Logo from './Logo';
import ShoppingCart from './ShoppingCart';

import IconHamburger from '../../assets/svgs/hamburger-line.svg';
import VeriSignLogo from './VeriSignLogo';

const SCGridMobile = styled(Grid)`
  ${Theme.media.lg`
    display: none;
  `};
`;

const SCHamburger = styled.div`
  width: ${remCalc(16)};
  margin-top: ${remCalc(26)};
  margin-left: ${remCalc(4)};
  cursor: pointer;
`;

const SCRightHandColumn = styled.div`
  margin-top: ${remCalc(15)};
  margin-bottom: ${remCalc(5)};
  display: inline-flex;
  right: 0;
  float: right;
`;

const SCLogin = styled(Anchor)`
  margin-top: ${remCalc(8)};
  margin-left: ${remCalc(25)};
  margin-right: ${remCalc(5)};
  line-height: 1.6;
`;

const SCAvatar = styled.div`
  margin-left: ${remCalc(10)};
`;

const HamburgerMenu = ({ onClick }) => (
  <SCHamburger onClick={onClick}>
    <IconHamburger size={22} />
  </SCHamburger>
);

const MobileHeader = ({
  showHamburger,
  logoLink,
  logoAlt,
  onHamburgerClick,
  shoppingCartUrl,
  loginUrl,
  showVeriSignLogo,
  showLoginButton,
  showShoppingCart,
  showAvatar,
  avatarMenuItems
}) => (
  <SCGridMobile>
    <Row>
      <Column sm={4} md={4}>
        {/* Hamburger Icon top left corner */}
        {showHamburger && <HamburgerMenu onClick={onHamburgerClick} />}
      </Column>
      <Column sm={4} md={4}>
        {/* Logo in the middle */}
        <Logo link={logoLink} alt={logoAlt} padded={true} />
      </Column>
      <Column sm={4} md={4}>
        {/* RHS controls */}
        <SCRightHandColumn>
          {showShoppingCart && <ShoppingCart url={shoppingCartUrl} />}
          {showLoginButton && <SCLogin href={loginUrl}>Login</SCLogin>}
          {showAvatar && (
            <SCAvatar>
              <Avatar menu={avatarMenuItems} />
            </SCAvatar>
          )}
          {showVeriSignLogo && <VeriSignLogo />}
        </SCRightHandColumn>
      </Column>
    </Row>
  </SCGridMobile>
);

export default MobileHeader;
